import { getUrlParameter } from './get-url-parameter.js';

// url parameters
const urlYearParam = getUrlParameter('year');
const urlMonthParam = getUrlParameter('month');
const urlAudienceParam = getUrlParameter('audience');
const urlTypeParam = getUrlParameter('type');
const urlProgramsParam = getUrlParameter('program');
const urlProductsParam = getUrlParameter('productorservice');
const urlTopicParam = getUrlParameter('topic');

const articles = document.querySelectorAll('.articles .article');


const noFilterResultsMsg = document.querySelector('#no-filter-results');
const filterMessageEl = document.querySelector('#filterMessage');

// filters
const allFilters = document.querySelectorAll('.filters select');

// pagination
const pageLength = 6;
let currentPage = 1;
const pagePrev = document.querySelector('.page-prev');
const pageSelect = document.querySelectorAll('.page-select');
const pageNext = document.querySelector('.page-next');

// buttons
const filterLatestNewsBtn = document.querySelector('#filterLatestNews');
const clearLatestNewsBtn = document.querySelector('#clearLatestNewsFilter');
const filterBulletinsBtn = document.querySelector('#filterBulletins');
const clearBulletinsFilterBtn = document.querySelector('#clearBulletinsFilter');

// declaring filtered array
let articlesArray = [...articles];

function hideAllArticles() {
  articles.forEach(function (article) {
    article.classList.add('d-none');
  });
}

function showAllArticles() {
  articles.forEach(function (article) {
    article.classList.remove('d-none');
  });
}

function resetAll() {
  // reset filters
  allFilters.forEach(function (filter) {
    filter.selectedIndex = 0;
  });
  articlesArray = [...articles];
  // hide no filter results message
  noFilterResultsMsg.classList.add('d-none');

  currentPage = 1;
  selectPage(document.querySelector('.page-' + currentPage));

  // accessibility message
  filterMessageEl.textContent = 'Now showing all articles';
}

function noResultsInfo(array) {
  const numOfArticles = array.length;
  (numOfArticles === 0)
    ? noFilterResultsMsg.classList.remove('d-none')
    : noFilterResultsMsg.classList.add('d-none');

  // accessibility message
  const articleLabel = (numOfArticles === 1) ? ' article' : ' articles';
  const filterMessage = 'Now showing ' + numOfArticles + articleLabel;

  filterMessageEl.textContent = filterMessage;
}

// latest news: filter
function filterLatestNews() {


  // selected filter values
  var filters = {
    audience: document.querySelector('#audience-filter').value,
    type: document.querySelector('#type-filter').value,
    programs: document.querySelector('#programs-filter').value,
    products_services: document.querySelector('#products-services-filter').value,
    topic: document.querySelector('#topic-filter').value,
	month: document.querySelector('#month-filter') ? document.querySelector('#month-filter').value : '',
    year: document.querySelector('#year-filter') ? document.querySelector('#year-filter').value : '' 
  };
  
  articlesArray = [...articles];
  // set filtered results
  articlesArray = articlesArray.filter(function(article) {

    // check if filter val is set, if empty default to article value for && return check below
    const audienceVal = (filters.audience !== '') ? filters.audience : article.dataset.audience;
    const typeVal = (filters.type !== '') ? filters.type : article.dataset.type;
    const programsVal = (filters.programs !== '') ? filters.programs : article.dataset.programs;
    const products_servicesVal = (filters.products_services !== '') ? filters.products_services : article.dataset.products_services;
	const monthVal = (filters.month !== '') ? filters.month : article.dataset.month;
    const yearVal = (filters.year !== '') ? filters.year : article.dataset.year; 

    return article.dataset.audience === audienceVal
      && article.dataset.type === typeVal
      && article.dataset.programs === programsVal
      && article.dataset.products_services === products_servicesVal
	  && article.dataset.month === monthVal
      && article.dataset.year === yearVal
      && article.dataset.topic.includes(filters.topic);
  });

  // Select 1st page
  currentPage = 1;
  selectPage(document.querySelector('.page-' + currentPage), false);
  displayPaginatedResults(articlesArray);

  // display no results information
  noResultsInfo(articlesArray);
}

function displayPaginatedResults(articles) {

  // hide all articles
  hideAllArticles();

  let iStart = (currentPage - 1) * pageLength;
  let iEnd = Math.min((currentPage * pageLength) - 1, articles.length - 1);

  for (let i = iStart; i <= iEnd; i++) {
    // Show the articles in the current page
    articles[i].classList.remove('d-none');
  }

  updatePaginationControls(articles);
}

function updatePaginationControls(articles) {
	// Verify if the News Pager is on the page, otherwise exit logic
	let newsPaging = document.querySelector('.news-pagination');
	if(newsPaging == null)
	  return;
  
  // Hide pagination controls if the results are empty
  
  if (articles == null || articles.length == 0) {
    document.querySelector('.news-pagination').classList.add('d-none');
  } else {
    document.querySelector('.news-pagination').classList.remove('d-none');
  }
  // show/hide appropriate page number links
  toggleVisibilityOfPageLinks(articles);
  // make sure the next/prev buttons are enabled or disabled appropriately
  checkNextPrevEnabled(articles);
}
// Show up to 5 pages in the pagination control
function toggleVisibilityOfPageLinks(articles) {
  let pageCount = Math.ceil(articles.length / pageLength);
  let pageLinks = document.querySelectorAll('.page-select');
  for (let i = 0; i < pageLinks.length; i++) {
    if (i < pageCount && i + 1 > currentPage - 3 && i + 1 < currentPage + 3) {
      pageLinks[i].parentNode.classList.remove('d-none');
    } else {
      pageLinks[i].parentNode.classList.add('d-none');
    }
  }
}

function checkNextPrevEnabled(articles) {
  let pageCount = Math.ceil(articles.length / pageLength);

  if (currentPage <= 1) {
    pagePrev.parentNode.classList.add('disabled');
  } else {
    pagePrev.parentNode.classList.remove('disabled');
  }

  if (currentPage >= pageCount) {
    pageNext.parentNode.classList.add('disabled');
  } else {
    pageNext.parentNode.classList.remove('disabled');
  }
}

function selectPage(pageLink, filter = true) {
  // Set current page number
  let page = pageLink.getAttribute('data-page');
  if (isNaN(page) == false && page >= 0) {
    currentPage = +page;
  }

  // Highlighting new link
  document.querySelectorAll('.page-item').forEach(item => {
    item.classList.remove('active');
  });
  pageLink.parentNode.classList.add('active');

  if (filter) {
	if(articlesArray === articles)
		displayPaginatedResults(articles);
	else
		displayPaginatedResults(articlesArray);
  }
}

// latest news: set filter value
function setLatestNewsValues() {
  document.querySelector('#audience-filter').value = (urlAudienceParam !== undefined) ? urlAudienceParam : '';
  document.querySelector('#type-filter').value = (urlTypeParam !== undefined) ? urlTypeParam : '';
  document.querySelector('#programs-filter').value = (urlProgramsParam !== undefined) ? urlProgramsParam : '';
  document.querySelector('#products-services-filter').value = (urlProductsParam !== undefined) ? urlProductsParam : '';
  document.querySelector('#topic-filter').value = (urlTopicParam !== undefined) ? urlTopicParam : '';

  filterLatestNews();
}

// e-bulletin: set filter value
function setEBulletinValues() {
  document.querySelector('#year-filter').value = urlYearParam;
  document.querySelector('#month-filter').value = urlMonthParam;

  filterLatestNews()
}

// mobile: collapse accordion
if (articles) {
  const windowWidth = window.innerWidth;
  if (windowWidth <= 991) {
    const newsFilters = document.querySelectorAll('.news-filters');
    newsFilters.forEach(function (newsFilter) {
      newsFilter.querySelector('button').click();
    });
  }
}

// events
filterLatestNewsBtn ? filterLatestNewsBtn.addEventListener('click', filterLatestNews) : '';
filterBulletinsBtn ? filterBulletinsBtn.addEventListener('click', filterLatestNews) : '';

clearLatestNewsBtn ? clearLatestNewsBtn.addEventListener('click', resetAll) : '';
clearBulletinsFilterBtn ? clearBulletinsFilterBtn.addEventListener('click', resetAll) : '';

// pagination events
pageSelect ? pageSelect.forEach(item => {
  item.addEventListener('click', function(e) {
    e.preventDefault();
    selectPage(this);
  });
}) : '';
pageNext ? pageNext.addEventListener('click', function(e) {
  e.preventDefault();
  currentPage++;
  selectPage(document.querySelector('.page-' + currentPage));
}) : '';
pagePrev ? pagePrev.addEventListener('click', function(e) {
  e.preventDefault();
  currentPage--;
  selectPage(document.querySelector('.page-' + currentPage));
}) : '';

// e-bulletin url parameters
(urlYearParam !== undefined && urlMonthParam !== undefined)
  ? setEBulletinValues()
  : '';

// latest news url parameters
(urlAudienceParam !== undefined || urlTypeParam !== undefined || urlProgramsParam !== undefined || urlProductsParam !== undefined || urlTopicParam !== undefined)
  ? setLatestNewsValues()
  : displayPaginatedResults(articles); // Paginate all articles



